module.exports = __webpack_public_path__ + "232cf607aad940036603e687701d4ee8.MP3";